export default {
  动漫详情: "动漫详情",
  剧情简介: "剧情简介",
  基本信息: "基本信息",
  声优阵容: "声优阵容",
  制作团队: "制作团队",
  猜你喜欢: "猜你喜欢",
  相似风格推荐: "相似风格推荐",
  观众热评: "观众热评",
  追番的朋友都在聊什么: "追番的朋友都在聊什么",
  来说说你的看法: "来说说你的看法吧",
  立即播放: "立即播放",
  开始追番: "开始追番",
  加入收藏: "加入收藏",
  分享: "分享",
  评分: "评分",
  话数: "话数",
  类型标签: "类型",
  上映时间: "上映时间",
  声优: "声优",
  导演: "导演",
  编剧: "编剧",
  动画制作: "动画制作",
  播放量: "播放量",
  万次播放: "万次播放",
} as Record<string, string>;